// Styled.
import styled, { css } from 'styled-components';
import { transparentize } from 'polished';

export const Mode = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  border: solid 1px var(--select-border-color, var(--select-bg, var(--select-bg)));
  background-color: transparent;
  padding: var(--xxs-padding) !important;
  color: var(--primary-color);
  border-radius: var(--select-border-radius, 0);
  width: 70px;
  cursor: pointer;

  ${({ isActive }) =>
    isActive &&
    css`
      border-color: var(--link);
      background-color: ${transparentize(0.9, '#71b7f8')};
    `}

  svg {
    margin: var(--xs-padding-vertical) 0 !important;
  }

  &:not(:last-child) {
    margin-right: var(--xs-padding-horizontal);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  :focus {
    outline: none;
  }
`;

export const Label = styled.span`
  font-size: 90%;
`;
